import React from 'react';

const keyboardRows = [
    ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'ö', 'ü', 'ó'],
    ['q', 'w', 'e', 'r', 't', 'z', 'u', 'i', 'o', 'p', 'ő', 'ú'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'é', 'á', 'ű'],
    ['í', 'y', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '-']
];

const Keyboard = ({ input, handler, insertCharacter, backspaceCharacter, insertEnter, isDuplicateClickEvent }) => {
    const handleCharClick = (char, e) => {
        if (isDuplicateClickEvent && isDuplicateClickEvent(e)) return;
        if (insertCharacter) insertCharacter(input, char);
        if (handler) handler(e);
        e.preventDefault();
        e.stopPropagation();
    };

    const handleBackspace = (e) => {
        if (isDuplicateClickEvent && isDuplicateClickEvent(e)) return;
        if (backspaceCharacter) backspaceCharacter(input);
        if (handler) handler(e);
        e.preventDefault();
        e.stopPropagation();
    };

    const handleEnter = (e) => {
        if (isDuplicateClickEvent && isDuplicateClickEvent(e)) return;
        if (insertEnter) insertEnter(input, e);
        if (handler) handler(e);
        e.preventDefault();
        e.stopPropagation();
    };

    return (
        <div>
            {/* Row 1 */}
            <div className="keyboard row1" onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }}>
                <div>
                    {keyboardRows[0].map(char => (
                        <label
                            key={char}
                            id={char}
                            level="1"
                            className="custom-button btn btn-info"
                            style={{}}
                            onClick={e => handleCharClick(char, e)}
                            onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }}
                            dangerouslySetInnerHTML={{ __html: char }}
                        />
                    ))}
                    <label
                        level="1"
                        className="custom-button btn btn-warning backspace-button"
                        style={{}}
                        onClick={handleBackspace}
                        onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }}
                    >&#8592;</label>
                </div>
            </div>
            {/* Row 2 */}
            <div className="keyboard row2" onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }}>
                <div>
                    {keyboardRows[1].map(char => (
                        <label
                            key={char}
                            id={char}
                            level="1"
                            className="custom-button btn btn-info"
                            style={{}}
                            onClick={e => handleCharClick(char, e)}
                            onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }}
                            dangerouslySetInnerHTML={{ __html: char }}
                        />
                    ))}
                </div>
            </div>
            {/* Row 3 */}
            <div className="keyboard row3" onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }}>
                <div>
                    {keyboardRows[2].map(char => (
                        <label
                            key={char}
                            id={char}
                            level="1"
                            className="custom-button btn btn-info"
                            style={{}}
                            onClick={e => handleCharClick(char, e)}
                            onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }}
                            dangerouslySetInnerHTML={{ __html: char }}
                        />
                    ))}
                    <label
                        id=""
                        level="1"
                        className="custom-button btn btn-info btn-warning enter-button"
                        onClick={handleEnter}
                        onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }}
                    >&#10005;</label>
                </div>
            </div>
            {/* Row 4 */}
            <div className="keyboard row4" onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }}>
                <div>
                    {keyboardRows[3].map(char => (
                        <label
                            key={char}
                            id={char}
                            level="1"
                            className="custom-button btn btn-info"
                            style={{}}
                            onClick={e => handleCharClick(char, e)}
                            onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }}
                            dangerouslySetInnerHTML={{ __html: char }}
                        />

                    ))}
                    <label
                        id=""
                        level="1"
                        className="custom-button btn btn-info space-button"
                        style={{ flexGrow: 4 }}
                        onClick={e => handleCharClick(" ", e)}
                        onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }}
                    ></label>
                </div>
            </div>
        </div>
    );
};

export default Keyboard;
